import React from 'react';

const appcuesEnabled = process.env.REACT_APP_APPCUES_ENABLED === "true";
class BaseListPage extends React.Component {

    componentDidMount() {
        if (appcuesEnabled && window.Appcues) {
            window.Appcues.track("VIEW_REGISTER", {
                workflowid: this.props.workflowItem.id
            });
        }
    }
}

export default BaseListPage;
